import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { GET_PROCESSES_WITH_PAGINATION } from './get-processes-with-pagination.hook';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { IHookCallbacks } from '../common.hooks.interfaces';

export const CREATE_PROCESS = gql`
  mutation createProcess($payload: ProcessInput!) {
    createProcess(payload: $payload) {
      _id
    }
  }
`;

export const useCreateProcess = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('employee');
  const [createProcess, { loading }] = useMutation(CREATE_PROCESS, {
    onCompleted: data => {
      if (data?.createProcess?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('process.notifications.created'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [GET_PROCESSES_WITH_PAGINATION],
  });

  return { createProcess, loading };
};
